import { setIsLoading } from '../../../../actions/general';
import { callApi } from '../../../../apiCaller';
import { COURSE_STATUS, DEFAULT_FN, TYPE_QUESTION } from '../../../../constants';
import { toastError, tryParseJSON } from '../../../../utils';
import { fetchSubscriberCourseDetailsRequest } from '../MyLeaning/actions';

export const SET_TAKE_SURVEY = 'setTakeSurvey';

export const API_SUBSCRIBER_TAKE_SURVEY = 'take-survey/:surveyId';
export const API_SUBSCRIBER_USER_SURVEY = 'user/survey';
export const API_SUBSCRIBER_USER_SURVEY_RESULT = 'user/survey/:userId/:productId/:surveyId/view-survey-result';

export const setTakeSurvey = (survey) => {
     return {
          type: SET_TAKE_SURVEY,
          payload: survey,
     };
};

export const fetchSubscriberTakeSurveyRequest = (surveyId) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SUBSCRIBER_TAKE_SURVEY.replace(':surveyId', surveyId), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setTakeSurvey(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const addSubscriberSurveyRequest = (values, nextDispatch) => (dispatch, getState) => {
     const { userSurvey, setShowQuestions, setStatus, questions, setIsWaiting = DEFAULT_FN, setSubmitting = DEFAULT_FN } = nextDispatch;

     const survey = getState().subscriber.takeSurvey;

     setIsWaiting(true);
     setSubmitting(true);

     const putAnswerByQuestionType = (questionType) => {
          switch (questionType) {
               case TYPE_QUESTION.ASK_FOR_ANSWER:
                    return TYPE_QUESTION.ASK_FOR_ANSWER;

               case TYPE_QUESTION.MULTIPLE_CHOICE:
                    return TYPE_QUESTION.MULTIPLE_CHOICE;

               case TYPE_QUESTION.LIKERT_SCALE:
                    return TYPE_QUESTION.LIKERT_SCALE;

               case TYPE_QUESTION.DROPDOWN_LIST_CHOICE:
                    return TYPE_QUESTION.DROPDOWN_LIST_CHOICE;
               default:
                    return '';
          }
     };

     const userAnswers = Object.keys(values)
          .map((key) => values[key])
          .sort((a, b) => a.order - b.order)
          .map((val) => {
               const questionFound = questions?.find((ques) => ques.id === val.questionId);
               const questionType = questionFound?.type;
               const questionIsRating = questionFound?.rating;

               const result = {
                    questionId: val.questionId,
                    questionName: questions?.find((ques) => ques.id === val.questionId)?.question,
                    answer: putAnswerByQuestionType(questionType) !== '' ? putAnswerByQuestionType(questionType) : val.answer,
                    answerName: putAnswerByQuestionType(questionType) !== '' ? val.answer : val.answerName,
                    answerValue: val.answerValue,
                    questionIsRating,
               };

               if (val.otherOption) {
                    result.otherOption = val.otherOption;
               }

               if (val.otherAnswer) {
                    result.otherAnswer = val.otherAnswer;
               }

               return result;
          });

     const userSurveyResults = { ...userSurvey, userAnswers };

     callApi(API_SUBSCRIBER_USER_SURVEY, 'POST', userSurveyResults)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const newSurvey = {
                    ...survey,
                    userSurveyResult: userAnswers,
               };
               setStatus(COURSE_STATUS.COMPLETED);
               dispatch(setTakeSurvey(newSurvey));
               dispatch(fetchSubscriberCourseDetailsRequest(userSurvey.courseId));
          })
          .finally(() => {
               setIsWaiting(false);
               setSubmitting(false);
               setShowQuestions(false);
          });
};

export const fetchUserSurveyResultRequest = async (userId, productId, surveyId) => {
     const endpoint = API_SUBSCRIBER_USER_SURVEY_RESULT.replace(':userId', userId).replace(':productId', productId).replace(':surveyId', surveyId);

     return await callApi(endpoint, 'GET').then((response) => {
          if (response.status !== 200) {
               return;
          }

          const surveyResultRes = response.data;
          const answersResultRes = tryParseJSON(surveyResultRes.userAnswers) || [];

          return answersResultRes;
     });
};

//TP-195 add test mode, action autoComplete
export const autoCompleteRequest = (userAnswers, nextDispatch) => (dispatch, getState) => {
     const { userSurvey, setShowQuestions, setStatus, setIsWaiting } = nextDispatch;
     const survey = getState().subscriber.takeSurvey;
     const values = { ...userSurvey, userAnswers };

     if (setIsWaiting) {
          setIsWaiting(true);
     }

     callApi(API_SUBSCRIBER_USER_SURVEY, 'POST', values).then((response) => {
          setShowQuestions(false);

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const newSurvey = {
               ...survey,
               userSurveyResult: values,
          };
          dispatch(setTakeSurvey(newSurvey));
          dispatch(fetchSubscriberCourseDetailsRequest(userSurvey.courseId));
          setStatus(COURSE_STATUS.COMPLETED);
          if (setIsWaiting) {
               setIsWaiting(false);
          }
     });
};
